/**
 * AI Notes feature action types.
 */
export const SET_AI_NOTES_SUMMARY = 'SET_AI_NOTES_SUMMARY';
export const SET_AI_NOTES_LOADING = 'SET_AI_NOTES_LOADING';
export const SET_AI_NOTES_ERROR = 'SET_AI_NOTES_ERROR';
export const CLEAR_AI_NOTES = 'CLEAR_AI_NOTES';
/** 停止会中自动总结定时器 */
export const STOP_AI_NOTES_POLL = 'STOP_AI_NOTES_POLL';
/** 打开/关闭「更多」唤起的 AI 纪要侧栏 */
export const SET_AI_NOTES_PANEL_VISIBLE = 'SET_AI_NOTES_PANEL_VISIBLE';
/** 下次自动总结的目标时间戳（epoch ms） */
export const SET_AI_NOTES_NEXT_SUMMARY_AT = 'SET_AI_NOTES_NEXT_SUMMARY_AT';
/** 启动/重置 2 分钟自动总结循环 */
export const START_AI_NOTES_AUTO_SUMMARY = 'START_AI_NOTES_AUTO_SUMMARY';
